/**
 * AI対応策提案サービス
 * Claude APIを使用したリスク分析・対応策提案機能
 */

import apiClient from '../../lib/apiClient';

// 対応策の型定義
export interface Countermeasure {
  title: string;
  description: string;
  priority: 'high' | 'medium' | 'low';
  estimatedEffort: string;
}

// AI対応策レスポンスの型定義
export interface AIAdviceResponse {
  summary: string;
  countermeasures: Countermeasure[];
  cautions: string[];
  nextActions: string[];
  relatedLaws: string[];
  isAIGenerated?: boolean;
}

/**
 * AI対応策提案サービス
 */
export const aiAdviceService = {
  /**
   * リスク項目に対するAI対応策を取得
   * @param projectId 案件ID
   * @param checkItemId チェック項目ID
   * @returns AI対応策レスポンス
   */
  async getRiskAdvice(projectId: string, checkItemId: string): Promise<AIAdviceResponse> {
    const response = await apiClient.post<AIAdviceResponse>(
      `/api/projects/${projectId}/risks/${checkItemId}/advice`
    );
    return response.data;
  },
};
